import { render, staticRenderFns } from "./withdrawal.vue?vue&type=template&id=380b15f1&scoped=true&"
import script from "./withdrawal.vue?vue&type=script&lang=js&"
export * from "./withdrawal.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal.vue?vue&type=style&index=0&id=380b15f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380b15f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('380b15f1')) {
      api.createRecord('380b15f1', component.options)
    } else {
      api.reload('380b15f1', component.options)
    }
    module.hot.accept("./withdrawal.vue?vue&type=template&id=380b15f1&scoped=true&", function () {
      api.rerender('380b15f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/withdrawal.vue"
export default component.exports